import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=340ec95b&scoped=true"
import script from "./paginator.vue?vue&type=script&setup=true&lang=js"
export * from "./paginator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./paginator.vue?vue&type=style&index=0&id=340ec95b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ec95b",
  null
  
)

export default component.exports